<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Exportar</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">          
          <div class="system-table table-container">
            <div class="system-table-conteiner">
              <table>
                <thead>
                  <tr>
                    <th>Arquivo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let type of exportTypes">
                    <td class="title">{{ type.tipo }}</td>
                    <td class="btn-icon-td">
                      <div class="btn-icon">
                        <span class="icon-table icon-table-text m-b" (click)="downloadFile(type.download)">
                          Download
                        </span>
                        <span class="icon-table icon-table-text" (click)="gerarLink(type.download, template)">
                          Gerar Link
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Gerar Link</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>

  <app-system-loader [loader]="loader"></app-system-loader>

  <div class="modal-body" *ngIf="modalLogin && !loader">
    <p class="text-center">Para gerar o link é necessário informar novamente o usuário e senha do sistema</p>
    <form [formGroup]="form" (ngSubmit)="login()" class="table-form">
      <div class="form-group row">
        <div class="col-sm-12">
          <label class="col-form-label" for="usuario">Usuário</label>
          <input type="text" id="usuario" class="form-control" formControlName="usuario" required maxlength="11" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <label class="col-form-label" for="senha">Senha</label>
          <input type="password" id="senha" class="form-control" formControlName="senha" required />
        </div>
      </div>
      <div class="hr-line-dashed"></div>
      <div class="form-group row">
        <div class="col-sm-4 col-sm-offset-2">
          <button class="btn btn-primary" type="submit" [disabled]="!form.valid">Gerar</button>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-body" *ngIf="!modalLogin && !loader">
    <div class="form-group row">
      <div class="col-sm-12">
        <label class="col-form-label" for="usuario">Link</label>
        <input type="text" id="usuario" class="form-control" value="{{ link.link }}" disabled />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <label class="col-form-label" for="senha">Link (sem multilinha)</label>
        <input type="text" id="usuario" class="form-control" value="{{ link.linkMonolinha }}" disabled />
      </div>
    </div>

    <br><br>
    <h4>HTTP request header parameters</h4>
    <div class="form-group row">
      <div class="col-sm-12">
        <label class="col-form-label" for="usuario">entidade-id</label>
        <input type="text" id="usuario" class="form-control" value="{{ entidade }}" disabled />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <label class="col-form-label" for="usuario">Content-type</label>
        <input type="text" id="usuario" class="form-control" value="{{ link.contentType }}" disabled />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <label class="col-form-label" for="senha">Authorization</label>
        <input type="text" id="usuario" class="form-control" value="{{ link.authorization }}" disabled />
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>